import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { MyNotifications } from '@app/core/models';
import { ApiService } from '@app/core/services/api.service';

const MY_NOTIFICATIONS_SESSION_KEY = 'my-notifications-shown';
/**
 * MyNotificationsService
 */
@Injectable({ providedIn: 'root' })
export class MyNotificationsService {
  get notifiedFlag(): boolean {
    return this._notifiedFlag || this.getSessionNotifiedFlag();
  }

  set notifiedFlag(value: boolean) {
    this._notifiedFlag = value;
    this.setSessionNotifiedFlag(value);
  }
  private _notifiedFlag = false;
  /**
   * url
   */
  public url;

  /**
   * constructor
   * @param apiService
   * @param redux
   */
  constructor(private apiService: ApiService) {}

  shouldDisplayNotification(notifications: any): boolean {
    return Boolean(
      notifications?.loaded &&
        !notifications?.acknowledge &&
        notifications?.list?.htmlContent &&
        !this.notifiedFlag,
    );
  }

  markNotificationAsDisplayed(): void {
    this.notifiedFlag = true;
  }

  /**
   * getMyNotifications
   * @returns {Observable<MyNotiifcation[]>}
   */
  getMyNotifications(programKey: string): Observable<MyNotifications[]> {
    const options = {
      headers: {
        programKey,
      },
    };
    return this.apiService.get('/notification', options);
  }

  private getSessionNotifiedFlag(): boolean {
    const storage = this.getSessionStorage();
    return storage
      ? storage.getItem(MY_NOTIFICATIONS_SESSION_KEY) === 'true'
      : false;
  }

  private setSessionNotifiedFlag(value: boolean): void {
    const storage = this.getSessionStorage();
    if (!storage) {
      return;
    }

    if (value) {
      storage.setItem(MY_NOTIFICATIONS_SESSION_KEY, 'true');
      return;
    }

    storage.removeItem(MY_NOTIFICATIONS_SESSION_KEY);
  }

  private getSessionStorage(): Storage | null {
    if (typeof window === 'undefined') {
      return null;
    }

    try {
      return window.sessionStorage;
    } catch (error) {
      return null;
    }
  }
}
